/**
 * Resolve product-type slug to media type code (for element path detection).
 * Used to distinguish category/DLP routes from product-type routes.
 */
export const getMediaType = (string) => {
  switch (string) {
    case 'stock-video':
    case 'stock-animation':
      return 'video';
    case 'stock-music':
      return 'music';
    case 'after-effects-template':
    case 'after-effects-preset':
      return 'ae';
    case 'premiere-pro-template':
    case 'premiere-pro-preset':
    case 'motion-graphics-template':
      return 'pr';
    case 'apple-motion-template':
      return 'fcp';
    case 'davinci-resolve-template':
    case 'davinci-resolve-macro':
      return 'resolve';
    case 'stock-image':
      return 'image';
    case '3d-model':
      return '3d';
    case 'sound-effect':
      return 'sfx';
    case 'lottie-animation':
      return 'lottie';
    case 'product':
      return 'product';
    case 'c':
      return 'collection';
    default:
      return null;
  }
};

/**
 * Convert URL mediaType segment to API/media type code.
 */
export const convertRouteToMediaTypeCode = (routePath) => {
  if (!routePath) {
    return null;
  }
  switch (routePath) {
    case 'after-effects':
    case 'after-effects-templates':
      return 'ae';
    case 'premiere-pro':
    case 'premiere-pro-templates':
      return 'pr';
    case 'sound-effects':
      return 'sfx';
    case 'apple-motion':
    case 'apple-motion-templates':
      return 'fcp';
    case 'davinci-resolve':
    case 'davinci-resolve-templates':
      return 'resolve';
    case 'image-prompts':
      return 'prompt';
    case 'stock-image':
      return 'image';
    case 'video':
    case 'animation':
      return 'video';
    default:
      return routePath.replace('-', '_');
  }
};
